import { signal } from '@preact/signals-react';
export const transcriptionSourceSignal = signal('file');
export const deviceSignal = signal(undefined);
export const setTranscriptionSourceSignal = (newState) => {
    if (newState !== transcriptionSourceSignal.value) {
        transcriptionSourceSignal.value = newState;
    }
};
export const setDeviceSignal = (newState) => {
    if (newState !== deviceSignal.value) {
        deviceSignal.value = newState;
    }
};
